import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import * as icons from './icons/Social';

const Container = styled.div`
  text-align: center;
`;

const Link = styled.a`
  display: inline-block;
  margin: 0 5px;
`;

const SocialSharing = ({
  networks, namespace, onShare,
}) => (
  <Container>
    {networks.map((network) => {
      const {
        id,
        url,
        title = `Share on ${id}`,
        ...rest
      } = network;
      const Icon = icons[id];

      const handleClick = (event) => {
        if (!onShare) return;

        onShare({ event, ...network });
      };

      return (
        <Link
          key={id}
          href={url}
          id={`${namespace}-social-share-${id}`}
          data-tracking-value={id}
          onClick={handleClick}
          target="_blank"
          rel="noopener noreferrer"
          alt={title}
          {...rest}
        >
          <Icon />
        </Link>
      );
    })}
  </Container>
);

SocialSharing.defaultProps = {
  onShare: undefined,
};

SocialSharing.propTypes = {
  networks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
  })).isRequired,
  namespace: PropTypes.string.isRequired,
  onShare: PropTypes.func,
};

export default SocialSharing;
